<template>
  <div class="modal" v-show="modal">
    <div class="modal-wraper">
        <div class="sign-modal modal-item">
            <div class="sign-title modal-title">
                <span class="text">标题</span>
                <input  v-model="title" class="input" type="text" ref="title-text" autofocus>
            </div>
            <div class="sign-class modal-class">
                <span class="text">班级</span>
                <span class="input class" @click="selectClass" v-show="!chooseClass" :class="noChooseClass==true?'no-choose-class':''">
                    <span class="default" v-if="classSelectSure.length==0">选择班级</span>
                    <span class="text" v-if="classSelectSure.length==1"><span class="one">{{classSelectSure[0]}}</span></span>
                    <span class="text" v-if="classSelectSure.length>1">
                        <span class="two">{{classSelectSure[0]}}</span>
                        <span class="three">...等{{classSelectSure.length}}个班级</span>
                    </span>
                    <span class="iconfont icon-yemian-yizhankai"></span>
                </span>
                
                <div class="classes-modal"  v-show="chooseClass">
                    <div class="classes-list">    
                        <div class="close-cls-modal" @click="selectCancle"><span class="iconfont icon-guanbi"></span></div>                    
                        <CheckboxGroup v-model="classSelect" class="class-wraper" v-scrollBar v-if="classList.length>0">
                          <template v-for="item in classList">
                            <div :key="item.grade">{{item.grade}}</div>
                            <Checkbox class="item-class" v-for="classItem in item.classes" :key="classItem.classID" :label="classItem.classname" :data-classId="classItem.classID"></Checkbox>
                          </template>
                        </CheckboxGroup>
                        <div class="no-clist" v-if="classList.length==0">暂无班级，请先去添加班级。</div>
                        <div class="operation">
                            <span class="sure" @click="selectedSure">确定</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sign-growth" v-if="type === 1">
                <span class="text">成长值</span>
                <Select name="growth" v-model="growth">
                    <Option v-for="(_, index) in 7" :key="index" :value="index">{{index}}</Option>
                </Select>
            </div>
            <div class="sign-people modal-people" v-if="type == 3">
                <span class="text">人数</span>
                <div class="person-num">
                    <span class="default" @click="selectedPerson">
                        <span>{{personNum}}人</span><span class="iconfont icon-sanjiao"></span>
                    </span>
                    <div class="person-selected" v-scrollBar v-show="numSelected">
                        <span v-for="item in 10" :key="item" :class="personNum == item?'person-choose':''" @click="selectedTrue(item)">{{item}}人</span>
                    </div>
                </div>
            </div>
            <div class="sign-choose" v-if="type == 2">
                <div class="text">选项</div>
                <div class="max-choose" @click="startSelect"><span>{{chooseText}}</span><span class="iconfont icon-sanjiao"></span></div>
                <ul class="max-choose-list" v-show="isSelected">
                    <li v-for="item in chooseList.length-1" :key="item" :class="item == chooseItem?'selected':''" @click="chooseSelect(item)">最多选择{{item}}个</li>
                </ul>
                <div class="sign-choose-list">
                    <ul>
                        <li v-for="(item,index) in chooseList" :key="index">
                            <span class="option">{{item.option}}</span>
                            <input class="text" type="text" placeholder="请输入选项或教师口述" v-model.trim="item.text">
                            <span class="iconfont icon-lei_guanbi del-choose" v-if="index>=2" @click="delChoose(index)"></span>
                        </li>
                    </ul>
                    <div class="add-choose" @click="addChoose">
                        <span class="iconfont icon-jiahao"></span><span>选项</span> 
                    </div>
                </div>
            </div>
        </div>
        <div class="start">
            <span @click="startActivity" :class="classIds.length>0?'can-start':''">立即开始</span>
        </div>
        <div class="close" @click="closeModal"><span class="iconfont icon-guanbi"></span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props:{
    type: Number,
    modal:Boolean,
    modalTitle:String,
  },
  data () {
    return {
        classList:[],
        classSelect:[],
        classSelectSure:[],
        chooseList:[{'option':'A','text':''},{'option':'B','text':''}],
        isSelected:false,
        chooseItem:1,
        chooseText:'',
        chooseClass:false,
        classIds:[],
        title:'',
        userId:0,
        personNum:5,
        numSelected:false,
        noChooseClass:false,
        limitTime:0,
        growth: 3,
    }
  },
  methods:{
    closeModal:function(){
        this.$emit("closeModal");
        this.chooseItem=1;
        this.chooseList=[{'option':'A','text':''},{'option':'B','text':''}];
    },
    selectedSure:function(){   
        this.noChooseClass = false;  
        this.classSelectSure = this.classSelect;
        this.classIds = [];   
        this.classItems=[];
        var eleArr = $('.ivu-checkbox-wrapper-checked');
        for(var i = 0; i < eleArr.length; i++){
           this.classIds.push(parseInt($(eleArr[i]).attr('data-classid')));
           this.classItems.push({
               classId:parseInt($(eleArr[i]).attr('data-classid')),
               className:$(eleArr[i]).find("input").val()
           })
        }
        this.chooseClass = false;
    },
    selectCancle:function(){
        this.chooseClass = false;
        this.classIds = [];   
        this.classItems=[];
        this.classSelect=[];
    },
    selectClass:function(){
        this.chooseClass = true;
        this.classSelect = this.classSelectSure;
    },
   startSelect:function(){
       this.isSelected = !this.isSelected
   },
   chooseSelect:function(index){
       this.chooseItem = index;
       this.chooseText = '最多选择'+index+'个'
       this.isSelected = false;
   },
   selectedPerson:function(){
       this.numSelected = !this.numSelected;
   },
   selectedTrue:function(num){
       this.personNum = num;
       this.numSelected = false;
   },
   //增加试题选项
   addChoose:function(){
       if(this.chooseList.length<10){
        var newChoice = {
                        text: ""
                    };
        this.chooseList.push(newChoice);
        for (var i = 0; i < this.chooseList.length; i++) {
            this.chooseList[i].option = String.fromCharCode('A'.charCodeAt(0) + i); //增加ABCD选项
        }
       }else{
           this.$Message.warning('选项最多为10个');
       }
       
   },
   //删除试题选行
   delChoose:function(index){
        this.chooseList.splice(index, 1);
        for (var i = 0; i < this.chooseList.length; i++) {
            this.chooseList[i].option = String.fromCharCode('A'.charCodeAt(0) + i); //增加ABCD选项
        }
   },
   //发起活动
   startActivity:function(){
       this.limitTime++;
       if(this.classIds.length == 0){
        //    this.$Message.warning('请选择班级');
           this.noChooseClass = true;
           return;
       }
    //    if(this.activityType == 2){
    //       for(var i = 0; i < this.chooseList.length; i++){
    //         if(this.chooseList[i].text == ''){
    //             this.$Message.warning('选项不能为空');
    //             return;
    //         }
    //       }
    //    }
       if(this.limitTime == 1){
        switch(this.activityType){
            case 1:this.startSignAct();break;
            case 2:this.startVoteAct();break;
            case 3:this.startResponderAct();break;
            // case 4:this.startDiscussAct();break;
            // case 5:this.startPick();break;
            default:break;
        }
       }
   },
   //发起签到
  startSignAct:function(){
      var userId = this.userId;
      var that = this;
      if(that.title.length>200){
         this.$Message.warning('标题不能超过200个字'); 
         return;
      }
        that.$http.post(that.baseURL1+'/newAttendance/publishClassesAttendanceRecord',
        {'location':'116.14,39.91','userID':userId,'time':-1,'growth': this.growth,'classID':that.classIds,'type':1,'refreshCode':1,'draft':0,'isGPS':false,'title':that.title,'from':'pc'})
        .then((res)=>{
         if(res.data.attendanceID>0){
             that.common.setCookie('activityId',res.data.attendanceID)
             that.common.setCookie('type',1);
             that.closeModal();
             that.appScreen(userId,1,res.data.attendanceID)
             that.limitTime = 0;
         }else{
              this.$Message.warning('发起失败');
         }
       })
  },
  //发起投票
  startVoteAct:function(){
      var classIds = this.classIds;
      var options = [];
      if(this.title.length>200){
         this.$Message.warning('标题不能超过200个字'); 
         return;
      }
      for(var i = 0; i < this.chooseList.length;i++){
          options.push({
              'type':1,
              'value':this.chooseList[i].text
          })
      }
      var vote = {
          'id':0,
          'userId':this.userId,
          'title':this.title,
          'state':2,
          'selectableCount':this.chooseItem,
          'growth':0,
          'startDate':0,
          'endDate':0,
          'duration':86400000
      }
      var that=this;
      that.$http.post(that.baseURL1+'/voteV2/save',{'userId':this.userId,'vote':vote,'classIds':classIds,'options':options})
        .then((res)=>{
         if(res.data.success){
           that.common.setCookie('activityId',res.data.voteId)
           that.common.setCookie('type',2);
           that.closeModal();
           that.appScreen(that.userId,2,res.data.voteId)
           that.limitTime = 0;
         }else{
              this.$Message.warning('发起失败');
         }
       })
  },
  //发起抢答
  startResponderAct:function(){
      var userId = this.userId;
      var that = this;
      if(that.title.length>200){
         this.$Message.warning('标题不能超过200个字'); 
         return;
      }
      that.$http.post(that.baseURL1+'/interlocution/publish',
      {'type':1,'userId':userId,'title':that.title,'classes':that.classItems,count:that.personNum})
        .then((res)=>{
         if(res.data.interlocutionId>0){
           that.common.setCookie('activityId',res.data.interlocutionId)
           that.common.setCookie('type',3)
           that.closeModal();
           that.appScreen(userId,3,res.data.interlocutionId);
           that.limitTime = 0;
         }else{
              this.$Message.warning('发起失败');
         }
       })      
  },
  // 发起讨论
  // startDiscussAct:function(){
  //     var that = this;
  //     if(that.title.length>200){
  //        this.$Message.warning('标题不能超过200个字'); 
  //        return;
  //     }
  //     that.$http.post(that.baseURL1+'/discussion/publishTopic',
  //       {'title':that.title,'classesID':that.classIds.join(","),'isLimitDiscussTime':1,'userID':this.userId,'discussType':0})
  //       .then((res)=>{
  //       if(res.data>0){
  //          that.common.setCookie('activityId',res.data)
  //          that.common.setCookie('type',4);
  //          that.closeModal();
  //          that.appScreen(that.userId,4,res.data);
  //          that.limitTime = 0;
  //       }else{
  //             this.$Message.warning('发起失败');
  //        }
  //      })     
  // },
  // 发起选人
  // startPick () {
  //     let that = this
  //     if (that.title.length > 200) {
  //         this.$Message.warning('标题不能超过200字')
  //         return
  //     }
  //     console.log(that.classIds)
  //     that.$http.post(that.baseURL1 + '/classquestion/publish', {'title': that.title, 'classQuestionId': -1, 'userId': this.userId, 'draft': 0, 'classes': that.classItems})
  //       .then((res) => {
  //           if (res.data.code === 200) {
  //               that.common.setCookie('activityId', res.data.id)
  //               that.common.setCookie('type', 5)
  //               that.closeModal()
  //               that.appScreen(that.userId, 5, res.data.id)
  //               that.limitTime = 0
  //           } else {
  //               that.$Message.warning('发起失败');
  //           }
  //       })
  // },
  //活动发起成功后发送投屏请求
  appScreen:function(userId,type,activityId){
      var that = this;
      var Authorization= this.common.getCookie('Authorization')
      that.$http.post(that.baseURL+'/appscreen/createScreen',{
          'userId':userId,
          'type':type,
          'activityId':activityId,
          'sender':'pc'
      },{headers: {
            'Authorization': Authorization
        }}).then((res)=>{
        switch(type){
            case 1:
                if(window.location.href.indexOf("/screenIndex/signIn")!=-1){
                window.location.reload();
                }else{
                this.$router.replace({path: '/screenIndex/signIn'});
                }
            break;
            case 2:
                if(window.location.href.indexOf("/screenIndex/vote")!=-1){
                    window.location.reload();
                }else{
                    this.$router.replace({path: '/screenIndex/vote'});
                }
            break;
            case 3:
               if(window.location.href.indexOf("/screenIndex/responder")!=-1){
                    window.location.reload();
                }else{
                    this.$router.replace({path: '/screenIndex/responder'});
                }
            break;
            case 4:
                if(window.location.href.indexOf("/screenIndex/discuss")!=-1){
                    window.location.reload();
                }else{
                    this.$router.replace({path: '/screenIndex/discuss'});
                }
            break;
            case 5:
                if (window.location.href.indexOf("/screenIndex/pick") != -1) {
                    window.location.reload()
                } else {
                    this.$router.replace({path: '/screenIndex/pick'})
                }
        }
      })
    }
  },
  mounted:function(){
      this.chooseText = '最多选择1个';
  },
  created:function(){
    var userID = this.common.getCookie('userId');
    this.userId = userID;
    var ocId = this.common.getCookie('ocId');
    var Authorization= this.common.getCookie('Authorization')
    var that = this;
    //获取班级列表
    //{ocId}
    if(ocId){
        that.$http.get(that.baseURL+'class/getClassListOrderByYear?userID=' + this.userId,{headers: {
                'Authorization': Authorization
            }}).then((res)=>{
               this.classList = res.data
        });
    }
  },
  watch:{
      type(newVal,oldVal){
          this.activityType = newVal;
      },
      modalTitle(newVal,oldVal){
          this.title = newVal;
      }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import 'modal.scss'
</style>



// WEBPACK FOOTER //
// src/components/modal/modal.vue